import React, { useState, useEffect, useRef } from "react";

const HiddenEasterEgg = () => {
  const [clicks, setClicks] = useState(0);
  const [showGame, setShowGame] = useState(false);

  const handleClick = () => {
    const newCount = clicks + 1;
    setClicks(newCount);
    if (newCount >= 5) {
      setClicks(0);
      setShowGame(true);
    }
  };

  return (
    <div>
      <button
        onClick={handleClick}
        className="w-36 h-8 bg-transparent hover:bg-gray-100/20 rounded transition"
      />
      {showGame && <PongGame onExit={() => setShowGame(false)} />}
    </div>
  );
};

const PongGame = ({ onExit }) => {
  const canvasRef = useRef(null);
  const [running, setRunning] = useState(true);
  const [score, setScore] = useState(0);
  const [level, setLevel] = useState(1);

  const WIDTH = 600;
  const HEIGHT = 400;

  const ball = useRef({ x: WIDTH / 2, y: HEIGHT / 2, dx: 3, dy: 3, size: 10 });
  const paddle = useRef({
    x: WIDTH / 2 - 50,
    y: HEIGHT - 20,
    width: 100,
    height: 10,
    speed: 7,
  });
  const keys = useRef({ left: false, right: false });

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft" || e.key.toLowerCase() === "a")
        keys.current.left = true;
      if (e.key === "ArrowRight" || e.key.toLowerCase() === "d")
        keys.current.right = true;
    };
    const handleKeyUp = (e) => {
      if (e.key === "ArrowLeft" || e.key.toLowerCase() === "a")
        keys.current.left = false;
      if (e.key === "ArrowRight" || e.key.toLowerCase() === "d")
        keys.current.right = false;
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    const draw = () => {
      ctx.clearRect(0, 0, WIDTH, HEIGHT);

      // ball
      ctx.beginPath();
      ctx.arc(ball.current.x, ball.current.y, ball.current.size, 0, Math.PI * 2);
      ctx.fillStyle = "red";
      ctx.fill();
      ctx.closePath();

      // paddle
      ctx.fillStyle = "blue";
      ctx.fillRect(
        paddle.current.x,
        paddle.current.y,
        paddle.current.width,
        paddle.current.height
      );

      // score & level
      ctx.fillStyle = "black";
      ctx.font = "16px Arial";
      ctx.fillText("Score: " + score, 10, 20);
      ctx.fillText("Level: " + level, WIDTH - 90, 20);
    };

    const update = () => {
      if (!running) return;

      // paddle movement
      if (keys.current.left && paddle.current.x > 0) {
        paddle.current.x -= paddle.current.speed;
      }
      if (
        keys.current.right &&
        paddle.current.x + paddle.current.width < WIDTH
      ) {
        paddle.current.x += paddle.current.speed;
      }

      // ball movement
      ball.current.x += ball.current.dx;
      ball.current.y += ball.current.dy;

      // wall bounce
      if (
        ball.current.x + ball.current.size > WIDTH ||
        ball.current.x - ball.current.size < 0
      ) {
        ball.current.dx *= -1;
      }
      if (ball.current.y - ball.current.size < 0) {
        ball.current.dy *= -1;
      }

      // paddle bounce
      if (
        ball.current.y + ball.current.size >= paddle.current.y &&
        ball.current.x >= paddle.current.x &&
        ball.current.x <= paddle.current.x + paddle.current.width
      ) {
        ball.current.dy *= -1;
        setScore((s) => {
          const newScore = s + 1;

          // кожні 5 очок підвищуємо рівень і швидкість
          if (newScore % 5 === 0) {
            setLevel((lvl) => lvl + 1);
            // трохи збільшуємо швидкість
            ball.current.dx *= 1.2;
            ball.current.dy *= 1.2;
          }

          return newScore;
        });
      }

      // game over
      if (ball.current.y - ball.current.size > HEIGHT) {
        setRunning(false);
      }
    };

    let frame;
    const loop = () => {
      update();
      draw();
      frame = requestAnimationFrame(loop);
    };

    loop();

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      cancelAnimationFrame(frame);
    };
  }, [running, score, level]);

  const restartGame = () => {
    ball.current = { x: WIDTH / 2, y: HEIGHT / 2, dx: 3, dy: 3, size: 10 };
    paddle.current = {
      x: WIDTH / 2 - 50,
      y: HEIGHT - 20,
      width: 100,
      height: 10,
      speed: 7,
    };
    setScore(0);
    setLevel(1);
    setRunning(true);
  };

  return (
    <div className="fixed inset-0 flex items-start justify-center pt-10 bg-black/40 z-50">
      <div className="bg-white p-4 rounded-2xl shadow-lg text-center">
        <p className="mb-2 font-bold">🏓 Пасхалка: Пінг-Понг</p>
        <canvas
          ref={canvasRef}
          width={WIDTH}
          height={HEIGHT}
          className="border"
        />
        <p className="mt-2 text-gray-600 text-sm">
          Керування: ← → стрілками на клаві
        </p>
        {!running && (
          <div className="mt-3">
            <p className="text-red-500 font-bold">Game Over 😅</p>
            <p className="mb-2">Ваш рахунок: {score}</p>
            <p className="mb-2">Досягнутий рівень: {level}</p>
            <button
              onClick={restartGame}
              className="px-3 py-1 mr-2 bg-green-200 rounded-xl hover:bg-green-300 transition"
            >
              Заново
            </button>
            <button
              onClick={onExit}
              className="px-3 py-1 bg-yellow-200 rounded-xl hover:bg-yellow-300 transition"
            >
              Вийти
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default HiddenEasterEgg;
